import styled from '@emotion/styled';

const HeroDescription = styled('div')({
  alignItems: 'center',
  display: 'flex',
  flexWrap: 'wrap',
});

export default HeroDescription;
